import { render, staticRenderFns } from "./body_selected.vue?vue&type=template&id=c3fec506"
import script from "./body_selected.vue?vue&type=script&lang=js"
export * from "./body_selected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports